<template>
  <div id="content-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-2 pb-4">
          <router-link :to="{ name: 'users.create' }">
            <b-button block variant="primary" outline size="lg">
              <i class="fas fa-plus"></i>
              Add
            </b-button>
          </router-link>
        </div>
      </div>
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body class="pt-0">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col>
                      <h4 class="card-title">Search by</h4>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-group class="mb-0">
                        <b-form-input
                          id="exampleInputText1"
                          type="text"
                          placeholder="enter name or email"
                          size="sm"
                          v-model="search"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </template>
          </iq-card>
        </b-col>
      </div>
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body>
              <b-table
                hover
                responsive
                :items="items"
                :fields="fields"
                class="mb-0 table-borderless"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="loading"
                data-cy="users-table"
                sort-icon-left
              >
                <template #table-busy>
                  <div class="text-center p-4" style="color: var(--iq-primary)">
                    <b-spinner class="align-middle mr-3"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(first_name)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(last_name)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(email)="data">{{ data.value }}</template>
                <template v-slot:cell(role)="data">{{
                  data.value.replaceAll("_", " ")
                }}</template>
                <template v-slot:cell(organizations)="data">
                    <b-badge
                      v-for="(item) in data.value"
                      :key="item.id"
                      pill
                      variant="primary"
                      class="mr-1"
                      >{{ item.name}}</b-badge
                    >
                </template>
                <template v-slot:cell(action)="data">
                  <b-button
                    variant="outline-success mr-2"
                    size="sm"
                    data-cy="reset-password-button"
                    @click="resetPassword(data.item.email)"
                  >
                    Reset password
                  </b-button>
                  <b-button
                    variant="outline-primary mr-2"
                    size="sm"
                    @click="$router.push(`/users/${data.item.id}/edit`)"
                  >
                    edit
                  </b-button>
                </template>
              </b-table>
            </template>
          </iq-card>
        </b-col>
      </div>
      <div class="row d-flex justify-content-center">
        <b-pagination
          value="3"
          size="md"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>
      <b-modal
        id="delete-modal"
        :visible="!!toDeleteItem"
        title="Delete user"
        @hidden="toDeleteItem = null"
      >
        <p>
          User
          <strong>
            {{
              toDeleteUser
                ? `${toDeleteUser.first_name} ${toDeleteUser.last_name} (${toDeleteUser.email})`
                : null
            }}
          </strong>
          will be deleted.
        </p>
        <p>Are you sure?</p>
        <template #modal-footer="{}">
          <b-button
            size="sm"
            variant="outline-dark"
            @click="toDeleteItem = null"
            >Cancel</b-button
          >
          <b-button size="sm" variant="danger" @click="deleteItem(toDeleteItem)"
            >Delete</b-button
          >
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { core } from "../../config/pluginInit";
import DeletedBadge from "./Components/DeletedBadge";
import formatGQLError from "../../Utils/formatGQLError";
import gql from "graphql-tag";
const LIST_USERS = gql`
  query listUsers(
    $where: users_bool_exp!
    $limit: Int
    $offset: Int
    $order_by: [users_order_by!]
  ) {
    users(order_by: $order_by, where: $where, limit: $limit, offset: $offset) {
      id
      first_name
      last_name
      email
      role
      organizations {
        organization {
          id
          name
        }
      }
    }
    users_aggregate {
      aggregate {
        count
      }
    }
  }
`;
const DELETE_USER = gql`
  mutation deleteUser($id: uuid!) {
    update_users_by_pk(pk_columns: { id: $id }, _set: { deleted_at: "now()" }) {
      id
    }
  }
`;
const SEND_RESET_CODE = gql`
  mutation sendResetCode($username: String!) {
    sendResetCode(username: $username) {
      result
    }
  }
`;

export default {
  name: "Users",
  data() {
    return {
      sortBy: "last_name",
      sortDesc: false,
      search: "",
      perPage: 200,
      currentPage: 1,
      rows: null,
      users: [],
      error: false,
      loading: false,
      fields: [
        { key: "first_name", title: "first name", sortable: true },
        { key: "last_name", title: "last name", sortable: true },
        { key: "email", title: "E-mail", sortable: true },
        { key: "role", title: "Role", sortable: true },
        { key: "organizations", title: "In organizations", sortable: true },
        { key: "action", title: "Action", sortable: false }
      ],
      toDeleteItem: null
    };
  },
  components: {
    DeletedBadge
  },
  apollo: {
    users: {
      query: LIST_USERS,
      fetchPolicy: "no-cache",
      variables() {
        const vars = {
          where: {},
          limit: this.perPage,
          offset: this.currentPage * this.perPage - this.perPage
        };

        if (this.sortBy !== "") {
          vars.order_by = {
            [this.sortBy]: this.sortDesc ? "desc" : "asc"
          };
        }

        // filter
        const searchPart = this.search
          ? {
              _or: [
                {
                  first_name: {
                    _ilike: `%${this.search}%`
                  }
                },
                {
                  last_name: {
                    _ilike: `%${this.search}%`
                  }
                },
                {
                  email: {
                    _ilike: `%${this.search}%`
                  }
                }
              ]
            }
          : null;

        const whereAttributes = [];

        const finalFilter = [];
        if (searchPart !== null) {
          finalFilter.push(searchPart);
        }
        if (whereAttributes.length > 0) {
          whereAttributes.forEach(att => finalFilter.push(att));
        }

        vars.where = {
          _and: finalFilter
        };

        return vars;
      },
      result({ data, loading, networkStatus }) {
        if (!loading) {
          this.rows = data.users_aggregate.aggregate.count;
        }
      }
    }
  },
  computed: {
    // items remaps campaigns for template
    items() {
      const d = this.users.map(user => {
        return {
          id: user.id,
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          role: user.role,
          organizations: user.organizations.map(({organization: {id, name}}) => ({id, name}))
        };
      });
      return d;
    },
    toDeleteUser() {
      if (!this.toDeleteItem) {
        return null;
      }
      const u = this.items.find(i => i.id === this.toDeleteItem);
      if (!u) {
        return null;
      }
      return u;
    }
  },
  methods: {
    async resetPassword(username) {
      try {
        await this.$apollo.mutate({
          mutation: SEND_RESET_CODE,
          variables: {
            username
          }
        });
        this.$toast.success(`User's password reset and code sent.`);
      } catch (error) {
        this.$toast.error(
          `Failed to reset user's password: ${formatGQLError(error)}`
        );
      }
    },
    async deleteItem(id) {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_USER,
          variables: {
            id
          }
        });
        this.$toast.success(`User deleted`);
        this.toDeleteItem = null;
      } catch (error) {
        this.$toast.error(`Failed to delete user : ${error.message}`);
      }
    }
  },
  mounted() {
    core.index();
  }
};
</script>
